/** @format */

import image01 from '../images/content-master/01.jpg';
import imageWebp01 from '../images/content-master/01.webp';

import image02 from '../images/content-master/02.jpg';
import imageWebp02 from '../images/content-master/02.webp';

import image03 from '../images/content-master/03.jpg';
import imageWebp03 from '../images/content-master/03.webp';

import image04 from '../images/content-master/04.jpg';
import imageWebp04 from '../images/content-master/04.webp';

import image05 from '../images/content-master/05.jpg';
import imageWebp05 from '../images/content-master/05.webp';

import image06 from '../images/content-master/06.jpg';
import imageWebp06 from '../images/content-master/06.webp';

import image07 from '../images/content-master/07.jpg';
import imageWebp07 from '../images/content-master/07.webp';

import image08 from '../images/content-master/08.jpg';
import imageWebp08 from '../images/content-master/08.webp';

import image09 from '../images/content-master/09.jpg';
import imageWebp09 from '../images/content-master/09.webp';

import zbrush from '../images/technologies/zbrush.png';
import photoshop from '../images/technologies/photoshop.png';

const contentMaster = [
  {
    id: '01',
    title: 'Personaje Cyborg',
    image: image01,
    imageWebp: imageWebp01,
    description:
      'Crea paso a paso este grandioso persona para coleccionables con acompañamiento online en vivo.',
    video: 'https://www.youtube.com/watch?v=RnFm-puWjYU'
  },
  {
    id: '02',
    title: 'Escultura CHAMANA',
    image: image02,
    imageWebp: imageWebp02,
    description:
      'Vive una gran experiencia realizando la CHAMANA donde aprenderás de manera profesional como realizar detalles de escultura avanzada.',
    video: 'https://www.youtube.com/watch?v=x4p2eu-6U_Q'
  },
  {
    id: '03',
    title: 'Personaje realista',
    image: image03,
    imageWebp: imageWebp03,
    description:
      'Crear modelos realistas es un gran reto que con nuestros entrenamiento lo podrás lograr, es momento de avanzaren tu carrera profesional.',
      video: 'https://www.youtube.com/watch?v=k9U0_3eSyXA'
  },
  {
    id: '04',
    title: 'The Guardian',
    image: image04,
    imageWebp: imageWebp04,
    description:
      'Crea junto con Libel este gran personaje femenino y encuentra poco a poco tu flujo de trabajo utilizando ZBrush y Photoshop',
    logos: [zbrush, photoshop],
    video: 'https://www.youtube.com/watch?v=1-AWvUlYT6c'
  },
  {
    id: '05',
    title: 'Salamandra',
    image: image05,
    imageWebp: imageWebp05,
    description:
      'El secreto para un aprendizaje efectivo en ZBrush es nunca parar de esculpir, la constancia hará que encuentres el camino correcto para realizar grandes personajes en corto tiempo.',
    logos: [zbrush, photoshop],
    video: 'https://www.youtube.com/watch?v=-q3P4ZM7b0I'
  },
  {
    id: '06',
    title: 'A la luz de las estrellas',
    image: image06,
    imageWebp: imageWebp06,
    description:
      'Realizar modelos Hardsurface es más fácil de lo que crees, solo debes seguir nuestros entrenamientos y no saltarte los procesos para llegar a óptimos resultados.',
    logos: [zbrush, photoshop],
    video: 'https://www.youtube.com/watch?v=_02iVwahe_A'
  },
  {
    id: '07',
    title: 'Naruto para impresión',
    image: image07,
    imageWebp: imageWebp07,
    description:
      'Crea paso a paso a Naruto y déjalo listo para impresión 3D',
      video: 'https://www.youtube.com/watch?v=Onw9yCPWUT8'
  },
  {
    id: '08',
    title: 'Dark Crystal',
    image: image08,
    imageWebp: imageWebp08,
    description:
      'Crea a este excelente personaje usando  ZBrush y marvelous designer',
      video: 'https://www.youtube.com/watch?v=QY7dYbB-z4k'
  },
  {
    id: '09',
    title: 'Vehículos para Videojuegos',
    image: image09,
    imageWebp: imageWebp09,
    description:
      'Crear vehículos para videojuegos es una experiencia que no te puedes perder.',
      video: 'https://www.youtube.com/watch?v=mQVs3w3Y06U'
  },
];

export default contentMaster;
